
import React from 'react';
import { ProgressBar } from '@/components/league-table/stats/components/ProgressBar';

interface StatRowProps {
  label: string;
  homeValue: number;
  awayValue: number;
  total?: number;
  useMaxTotal?: boolean;
  usePoints?: boolean;
  homeTeamStats: any;
  awayTeamStats: any;
}

const calculatePercentage = (value: number, total: number) => {
  if (total <= 0) return '0';
  const percentage = ((value / total) * 100);
  return isNaN(percentage) ? '0' : percentage.toFixed(1);
};

const calculatePointsPercentage = (points: number, matches: number) => {
  if (matches <= 0) return '0';
  const percentage = ((points / (matches * 3)) * 100);
  return isNaN(percentage) ? '0' : percentage.toFixed(1);
};

export const StatRow: React.FC<StatRowProps> = ({
  label,
  homeValue,
  awayValue,
  total,
  useMaxTotal,
  usePoints,
  homeTeamStats,
  awayTeamStats
}) => {
  let homePercentage, awayPercentage;
  
  if (useMaxTotal) {
    const maxTotal = Math.max(homeTeamStats.played || 0, awayTeamStats.played || 0) || 1;
    homePercentage = calculatePercentage(homeValue, maxTotal);
    awayPercentage = calculatePercentage(awayValue, maxTotal);
  } else if (usePoints) {
    homePercentage = calculatePointsPercentage(homeValue, homeTeamStats.played || 1);
    awayPercentage = calculatePointsPercentage(awayValue, awayTeamStats.played || 1);
  } else {
    const totalValue = total || homeTeamStats.played || 1;
    homePercentage = calculatePercentage(homeValue, totalValue);
    awayPercentage = calculatePercentage(awayValue, totalValue);
  }

  return (
    <div className="grid grid-cols-11 items-center gap-2">
      <div className="col-span-2 text-right text-blue-600 text-sm font-medium">
        {homeValue || 0} ({homePercentage}%)
      </div>
      <div className="col-span-3">
        <ProgressBar 
          percentage={homePercentage} 
          color="bg-blue-500" 
          direction="left" 
        />
      </div>
      <div className="col-span-1 text-center text-sm">{label}</div>
      <div className="col-span-3">
        <ProgressBar 
          percentage={awayPercentage} 
          color="bg-red-500" 
          direction="right" 
        />
      </div>
      <div className="col-span-2 text-left text-red-600 text-sm font-medium">
        {awayValue || 0} ({awayPercentage}%)
      </div>
    </div>
  );
};
